// @flow
import React, { Fragment } from 'react';
import PartnerHead from 'components/partner/PartnerHead';
import PartnerContent from '../PartnerContent';
import './PartnerPlaceholder.scss';

type Props = {};

const PartnerPlaceholder = (props: Props) => (
  <Fragment>
    <PartnerHead.Placeholder />
    <PartnerContent.Placeholder />
  </Fragment>
);

export default PartnerPlaceholder;



// WEBPACK FOOTER //
// ./src/components/partner/PartnerPlaceholder/PartnerPlaceholder.js